const callbackFns = {
  Header: {
    onBackButtonClick: () => ({ type: 'VIEW_HEADER_BACK_BUTTON_CLICK' }),
  },
  StaticNavigation: {
    onNavigationGameClick: (...args) => ({
      type: 'VIEW_SIDE_MENU_GAME_CLICK',
      payload: args[0],
    }),
    onNavigationGameInfoClick: (...args) => ({
      type: 'VIEW_SIDE_MENU_GAME_INFO_CLICK',
      payload: args[0],
    }),
    onNavigationCommandClick: (...args) => ({
      type: 'VIEW_SIDE_MENU_COMMAND_CLICK',
      payload: args[0],
    }),
    onItemClick: (...args) => ({
      type: 'VIEW_SIDE_MENU_ITEM_CLICK',
      payload: args[0],
    }),
    onMenuItemClick: (...args) => ({
      type: 'VIEW_HEADER_MENU_ITEM_CLICK',
      payload: args[0],
    }),
  },
  SideNavigation: {
    onItemClick: (...args) => ({
      type: 'VIEW_SIDE_MENU_ITEM_CLICK',
      payload: args[0],
    }),
  },
  GameDetailsHeader: {
    onBackButtonClick: () => ({ type: 'VIEW_HEADER_BACK_BUTTON_CLICK' }),
  },
  Category: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
    onRouteTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_ROUTE_ITEM_CLICK',
      payload: args[0],
    }),
    onLinkTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_LINK_ITEM_CLICK',
      payload: args[0],
    }),
    onViewAllClick: (...args) => ({
      type: 'VIEW_CATEGORY_VIEW_ALL_CLICK',
      payload: { path: args[0].path },
    }),
    onShuffleClick: (...args) => ({
      type: 'VIEW_CATEGORY_SHUFFLE_CLICK',
      payload: args[0],
    }),
  },
  CategoryDetails: {
    onGameTileClick: game => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: { game },
    }),
    onGameTileInfoClick: (game, path) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: { ...game, path },
    }),
    onClose: () => ({
      type: 'VIEW_SIDEBAR_OVERLAY_CLICK',
    }),
  },
  RecentlyPlayed: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
    onRouteTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_ROUTE_ITEM_CLICK',
      payload: args[0],
    }),
    onViewAllClick: (...args) => ({
      type: 'VIEW_CATEGORY_VIEW_ALL_CLICK',
      payload: { path: args[0].path },
    }),
  },
  BingoGames: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
    onRouteTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_ROUTE_ITEM_CLICK',
      payload: args[0],
    }),
  },
  GameDetails: {
    onGameButtonClick: (...args) => ({
      type: 'VIEW_GAME_DETAILS_BUTTON_CLICK',
      payload: args[0],
    }),
  },
  GameDetailsContent: {
    onGameButtonClick: (...args) => ({
      type: 'VIEW_GAME_DETAILS_BUTTON_CLICK',
      payload: args[0],
    }),
  },
  SearchCategory: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
    onViewAllClick: (...args) => ({
      type: 'VIEW_CATEGORY_VIEW_ALL_CLICK',
      payload: { path: args[0].path },
    }),
    onSearchResultsClick: () => ({ type: 'VIEW_SEARCH_RESULTS_CLICK' }),
  },
  SearchMoreResults: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
  },
  BottomNavigation: {
    onBottomNavigationItemClick: (...args) => ({
      type: 'VIEW_BOTTOM_MENU_ITEM_CLICK',
      payload: args[0],
    }),
    onBottomNavigationGameClick: (...args) => ({
      type: 'VIEW_BOTTOM_MENU_GAME_CLICK',
      payload: args[0],
    }),
    onBottomNavigationCommandClick: (...args) => ({
      type: 'VIEW_BOTTOM_MENU_COMMAND_CLICK',
      payload: args[0],
    }),
  },
  SearchInput: {
    onSearchWrapperClick: (...args) => ({
      type: 'VIEW_SEARCH_WRAPPER_CLICK',
      payload: args[0],
    }),
  },
  SearchBar: {
    onSearchWrapperClick: (...args) => ({
      type: 'VIEW_SEARCH_WRAPPER_CLICK',
      payload: args[0],
    }),
  },
  SearchHeader: {
    onChange: (...args) => ({
      type: 'VIEW_SEARCH_CHANGE',
      payload: { value: args[0], sourceType: args[1] },
    }),
    onClearButtonClick: () => ({ type: 'VIEW_SEARCH_CLEAR_CLICK' }),
    onSearchButtonClick: (...args) => ({
      type: 'VIEW_SEARCH_CLICK',
      payload: { value: args[0], sourceType: args[1] },
    }),
    onSoftKeyboardVisibilityChange: (...args) => ({
      type: 'VIEW_SOFT_KEYBOARD_VISIBILITY_CHANGED',
      payload: args[0],
    }),
    onSearchClose: () => ({ type: 'VIEW_SEARCH_CLOSE' }),
    onSubheaderItemClick: (...args) => ({
      type: 'VIEW_SEARCH_SUBHEADER_ITEM_CLICK',
      payload: { index: args[0], type: args[1] },
    }),
  },
  SearchHistory: {
    onClearRecentSearchesClick: () => ({
      type: 'VIEW_RECENT_SEARCHES_CLEAR_CLICK',
    }),
    onPhraseClick: (...args) => ({
      type: 'VIEW_SEARCH_PHRASE_CLICK',
      payload: { value: args[0], index: args[1], sourceType: args[2] },
    }),
  },
  Modal: {
    onModalOverlayClick: () => ({ type: 'VIEW_SIDEBAR_OVERLAY_CLICK' }),
    onModalBackButtonClick: () => ({ type: 'VIEW_MODAL_BACK_BUTTON_CLICK' }),
  },
  GameDetailsModal: {
    onModalOverlayClick: () => ({ type: 'VIEW_MODAL_OVERLAY_CLICK' }),
  },
  GameModal: {
    onGameModalCloseClick: () => ({ type: 'VIEW_CLOSE_GAME_MODAL_TRIGGER' }),
    onDepositClick: () => ({ type: 'VIEW_OPEN_DEPOSIT_GAME_MODAL' }),
    onOverlayClick: () => ({ type: 'VIEW_FULL_SCREEN_OVERLAY_CLICK' }),
  },
  ErrorContainer: {
    onErrorItemClick: (...args) => ({
      type: 'VIEW_ERROR_ITEM_CLICK',
      payload: args[0],
    }),
  },
  FloatingIcon: {
    onFloatingIconClick: (...args) => ({
      type: 'VIEW_FLOATING_ICON_CLICK',
      payload: args[0],
    }),
  },
  CookieBanner: {
    onCookieBannerClick: () => ({ type: 'VIEW_COOKIE_BANNER_CLICK' }),
  },
  Menu: {
    onItemClick: (...args) => ({
      type: 'VIEW_MAIN_MENU_ITEM_CLICK',
      payload: args[0],
    }),
    onMenuCloseClick: () => ({ type: 'VIEW_MAIN_MENU_CLOSE_CLICK' }),
  },
  SearchDesktopWrapper: {
    onOverlayClick: () => ({ type: 'VIEW_SEARCH_DESKTOP_OVERLAY_CLICK' }),
  },
  SearchSuggestions: {
    onPhraseClick: (...args) => ({
      type: 'VIEW_SEARCH_PHRASE_CLICK',
      payload: { value: args[0], index: args[1], sourceType: args[2] },
    }),
  },
  Steps: {
    onStepItemClick: (...args) => ({
      type: 'VIEW_STEP_ITEM_CLICK',
      payload: args[0],
    }),
    onStepVideoItemClick: (...args) => ({
      type: 'VIEW_VIDEO_ITEM_CLICK',
      payload: args[0],
    }),
  },
  BannerStandalone: {
    onBannerStandaloneItemClick: (...args) => ({
      type: 'VIEW_BANNER_STANDALONE_ITEM_CLICK',
      payload: args[0],
    }),
    onBannerStandaloneVideoLinkClick: (...args) => ({
      type: 'VIEW_VIDEO_ITEM_CLICK',
      payload: args[0],
    }),
  },
  VideoModal: {
    onVideoModalClose: (...args) => ({
      type: 'VIEW_VIDEO_MODAL_CLOSE_CLICK',
      payload: args[0],
    }),
  },
  ProvidersFilter: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
  },
  IdlePopup: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_IDLE_POPUP_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onPlayNowClick: (...args) => ({
      type: 'VIEW_IDLE_POPUP_PLAY_NOW_CLICK',
      payload: args[0],
    }),
    onCloseButtonClick: (...args) => ({
      type: 'VIEW_IDLE_POPUP_CLOSE_BUTTON_CLICK',
      payload: args[0],
    }),
    onCheckBoxClick: (...args) => ({
      type: 'VIEW_IDLE_POPUP_CHECKBOX_CLICK',
      payload: args[0],
    }),
  },
  JackpotBetWidget: {
    onGameTileClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_CLICK',
      payload: args[0],
    }),
    onGameTileInfoClick: (...args) => ({
      type: 'VIEW_CATEGORY_GAME_TILE_INFO_CLICK',
      payload: args[0],
    }),
  },
};

export default callbackFns;
